/**
 * Per-client media library content pillars (DDS). Backend validates the same IDs.
 * Expand MEDIA_CONTENT_PILLAR_UPLOAD_OPTIONS when enabling more pillars in upload UI.
 */
export const MEDIA_CONTENT_PILLAR_IDS = [
  'motivation',
  'education',
  'offer',
  'case_study',
];

export const MEDIA_CONTENT_PILLAR_LABELS = {
  motivation: 'Motivation',
  education: 'Education',
  offer: 'Offer',
  case_study: 'Case study',
};

/** Values shown in upload dropdowns (Task 4.4: offer enabled for DDS service marketing). */
export const MEDIA_CONTENT_PILLAR_UPLOAD_OPTIONS = ['motivation', 'offer'];
